import { createAction } from 'redux-actions';

export const reducerName = 'notification';

export interface Notification {
  type?: 'success' | 'error';
  message?: string;
}

export const openNotification = createAction<Notification>(`${reducerName}.OPEN`);
export const closeNotification = createAction(`${reducerName}.CLOSE`);
